<template>
  <div
    id="producer"
    v-loading="querySubLoading">
    <ManageSub
      v-if="showManageSub"
      :planList="allSubscriptions"
      @manage="handleManagePlanType"
      @choose="handleChoosePlanType">
    </ManageSub>
    <template v-else>
      <div
        v-if="paySuccess"
        class="paysuccess-info">
        <img
          class="all-right"
          src="@/assets/svg/allright.svg"
          alt="">
        <div class="pay-start">SUBSCRIPTION COMPLETE</div>
        <div v-if="postPayStatus">
          <div
            class="pay-info"
            v-if="postPayStatus == 'add'">
            Thank you, postpay user. This amount has been added to the pending payment, and the bill will be summarized on the settlement date.
          </div>
          <div
            class="pay-info"
            v-if="postPayStatus == 'manage'">
            Thank you for selecting the Postpay option. You will be invoiced for your usage at the end of the billing period.
          </div>
          <br>
          <div class="pay-info">You can start use it now.</div>
        </div>
        <div v-else>
          <div class="pay-info">
            Thank you, your payment has been successful.
            You can start use it now.
          </div>
          <div class="info-line"></div>
        </div>
        <div class="pay-content">
          <div
            class="info-item"
            v-for="[key, value] in Object.entries(payInfo)"
            :key="key">
            <span>{{ key }}</span>
            <span>{{ value }}</span>
          </div>
        </div>
        <div class="trial-footer">
          <div
            class="close"
            @click="handleCloseIframe">
            Close
          </div>
        </div>
      </div>
      <choose-plan
        v-else-if="!hasSub &&!querySubLoading"
        :nodeType="nodeType"
        :existPlan="subscription"
        :allSubscriptions="allSubscriptions"
        :chooseFrom="chooseFrom"
        @titlechange="titlechange"
        @reselectPlan="reselectPlan">
      </choose-plan>
      <Manage
        v-else-if="hasSub &&!querySubLoading"
        :chooseFrom="chooseFrom"
        :plan="subscription"
        @titlechange="titlechange"
        :nodeType="nodeType"
        @reselectPlan="reselectPlan">
      </Manage>
    </template>
    <Deactivate
      v-if="showCancel"
      @confirm="confirmDeactivate"
      @cancel="cancelDeactivate"></Deactivate>
  </div>
</template>

<script>
import ManageSub from './ManageSub.vue'
import ChoosePlan from './ChoosePlan.vue'
import Manage from './Manage.vue'
import Deactivate from './Deactivate.vue'
import { userHasSubscription, cancelSub, getPlans } from '@/common/checkuser.js'
import { mapState } from 'vuex'
import { Message, MessageBox } from 'element-ui'
const AddonsInfo = {
  mh_destlow_number: {
    // displayName: 'Low Video Bitrate Encoding',
    displayName: 'lowBitrate',
    key: 'destlowNumber',
    priceKey: 'destlow'
  },
  mh_desthigh_number: {
    // displayName: 'High Video Bitrate Encoding',
    displayName: 'highBitrate',
    key: 'desthighNumber',
    priceKey: 'desthigh'
  },
  mh_format_number: {
    displayName: 'outputStream',
    key: 'formatNumber',
    priceKey: 'format'
  },
  mh_source_number: {
    displayName: 'inputStream',
    key: 'inputNumber',
    priceKey: 'input'
  },
  mh_source_minute: {
    displayName: 'inputStream',
    priceKey: 'input'
  },
  mh_destlow_minute: {
    displayName: 'lowBitrate',
    priceKey: 'destlow'
  },
  mh_desthigh_minute: {
    displayName: 'highBitrate',
    priceKey: 'desthigh'
  },
  mh_format_minute: {
    displayName: 'outputStream',
    priceKey: 'format'
  },
  mh_plan_core_number: {
    displayName: 'core',
    key: 'coreNumber',
    priceKey: 'core'
  }
}
const PlansInfo = {
  mediahub_plan_monthly: {
    planDisplayName: 'Monthly',
    input: '$ 691.00/month',
    format: '$ 691.00/month',
    destlow: '$ 97.20/month',
    desthigh: '$ 291.60/month',
    style: {
      background: 'linear-gradient(274.86deg, #C18471 0%, #F7E6C0 100%)'
    }
  },
  mediahub_plan_1y: {
    planDisplayName: 'Yearly',
    input: '$ 8,294.00/year',
    format: '$ 8,294.00/year',
    destlow: '$ 1,108.00/year',
    desthigh: '$ 3,324.00/year',
    style: {
      background: 'linear-gradient(274.86deg, #94A5C9 0%, #E6EDFA 100%)'
    }
  },
  mediahub_plan_ppu: {
    planDisplayName: 'Pay per Use',
    input: '$ 1.36/hour',
    format: '$ 1.36/hour',
    destlow: '$ 2.03/hour',
    desthigh: '$ 6.09/hour',
    free: 'Free 20 minutes',
    style: {
      background: 'linear-gradient(274.86deg, #75C74D 0%, #E6FFD9 100%)'
    }
  },
  mediahub_plan_managed_1y: {
    planDisplayName: 'Yearly',
    save: '$2.91',
    core: '$385.00 /per 4 CPU Core',
    planPrice: '$385.00',
    style: {
      background: 'linear-gradient(274.86deg, #94A5C9 0%, #E6EDFA 100%)'
    }
  },
  mediahub_plan_managed_monthly: {
    planDisplayName: 'Monthly',
    core: '$35.00 /per 4 CPU Core',
    planPrice: '$35.00',
    style: {
      background: 'linear-gradient(274.86deg, #C18471 0%, #F7E6C0 100%)'
    }
  }
}
export default {
  components: {
    ChoosePlan,
    Manage,
    ManageSub,
    Deactivate
  },
  data () {
    return {
      querySubLoading: true,
      subscription: null,
      hasSub: false,
      paySuccess: false,
      postPayStatus: '', // manage add ''
      payInfo: {},
      showManageSub: false,
      manageSubList: [
        {
          id: 'cloud',
          sub: false,
          type: 'Monthly',
          style: {}
        },
        {
          id: 'node',
          sub: false,
          type: 'Yearly',
          style: {}
        }
      ],
      allSubscriptions: [],
      nodeType: '',
      chooseFrom: '',
      nodePlan: null,
      cloudPlan: null,
      showCancel: false,
      cancelPlanID: ''
    }
  },
  provide () {
    return {
      emailid: this.emailid,
      loadData: () => {
        this.querySubStatus()
      },
      paySuccess: (value) => {
        this.handlePaySuccess(value)
      },
      Cancel: (id) => {
        this.cancelPlanID = id
        this.showCancel = true
      },
      AddonsInfo,
      PlansInfo
    }
  },
  created () {
    const { nodeType, action } = this.iframeData
    this.showManageSub = false
    this.nodeType = nodeType
    this.querySubStatus()
    // 如果有sub 要判断是哪一种的
    // 新增显示两个sub页面
  },
  methods: {
    confirmDeactivate (description) {
      this.showCancel = false
      const params = {
        product: this.product,
        planId: this.cancelPlanID,
        description
      }
      this.querySubLoading = true
      cancelSub(params).then(() => {
        this.querySubLoading = false
        this.querySubStatus()
      }).catch((error) => {
        this.querySubLoading = false
        try {
          const { extensions } = error.graphQLErrors[0]
          console.log(extensions)
          const codes = ['80E00144', '80E00116']

          if (extensions && extensions.errorCode && codes.includes(extensions.errorCode)) {
            Message.error('Please settle any pending invoices')
          } else {
            Message.error('Failed to cancel subscription')
          }
        } catch (err) {
          Message.error('Failed to cancel subscription')
        }
      })
    },
    cancelDeactivate () {
      this.showCancel = false
    },
    initPage () {
      const { action } = this.iframeData
      // 禁用manage card页面
      this.showManageSub = false
    },
    handlePaySuccess (params) {
      if (params.type == 'POS-PAY') {
        this.payInfo = []
        this.postPayStatus = params.value
      } else {
        this.payInfo = params
        this.postPayStatus = ''
      }
      // this.$emit('titlechange', 'Subscribe to TVU Media Hub Service')
      this.$emit('titlechange', 'subscribeService')
      this.paySuccess = true
    },
    // 关闭弹窗, 支付成功下的关闭
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing',
        data: {
          checkOut: true
        }
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    // 查询订阅状态
    querySubStatus () {
      this.initPage()
      this.querySubLoading = true
      const params = {
        product: this.product,
        classification: 3,
        status: 0
      }
      userHasSubscription(params).then(({ data, errors }) => {
        if (data.subscription && data.subscription.subscriptions) {
          const list = data.subscription.subscriptions || []
          const subPlans = list.map(i => {
            if (Object.hasOwn(PlansInfo, i.planId)) {
              Object.assign(i, PlansInfo[i.planId])
            } else {
              Object.assign(i, {
                planDisplayName: i.name || i.planName || '',
                core: '',
                planPrice: '',
                style: {
                  background: 'linear-gradient(274.86deg, #C18471 0%, #F7E6C0 100%)'
                }
              })
            }
            return i
          })

          if (subPlans.length > 0) {
            // const nodePlan = subPlans.find(i => i.classification === 3 && (i.status == 0 || i.status == 6))
            // const cloudPlan = subPlans.find(i => i.classification === 1 && (i.status == 0 || i.status == 6) && i.planId != 'mediahub_plan_ppu')
            // this.nodePlan = nodePlan
            // this.cloudPlan = cloudPlan
            // Object.assign(this.manageSubList[1], {
            //   sub: Boolean(this.nodePlan?.planId),
            //   style: this.nodePlan?.style,
            //   type: this.planDisplayName(this.nodePlan?.planId),
            //   planId: this.nodePlan?.planId
            // })
            // Object.assign(this.manageSubList[0], {
            //   sub: Boolean(this.cloudPlan?.planId),
            //   style: this.cloudPlan?.style,
            //   type: this.planDisplayName(this.cloudPlan?.planId),
            //   planId: this.cloudPlan?.planId
            // })
            // this.manageSubList[1].sub = Boolean(this.nodePlan?.planId)
            // this.manageSubList[1].style = this.nodePlan?.style
            // this.manageSubList[1].type = this.planDisplayName(this.nodePlan?.planId)
            // this.manageSubList[0].sub = Boolean(this.cloudPlan?.planId)
            // this.manageSubList[0].style = this.cloudPlan?.style
            // this.manageSubList[0].type = this.planDisplayName(this.cloudPlan?.planId)
          }
          if (this.showManageSub) {
            // this.$emit('titlechange', 'Manage Subscriptions')
            this.$emit('titlechange', '')
          } else {
            if (subPlans.length > 0) {
              // this.planisSub = subPlans.findIndex(i => i.planId === this.planDetail.id) > -1
              // const item = this.nodeType == 'cloud' ? this.cloudPlan : this.nodePlan
              // const title = this.nodeType == 'cloud' ? 'Cloud Subscriptions' : 'Nodes Subscriptions'
              // const title = this.nodeType == 'cloud' ? 'cloudSubscription' : 'node'
              // if (!item) {
              //   this.hasSub = false
              //   this.subscription = null
              //   // this.$emit('titlechange', 'Choose a plan')
              //   this.$emit('titlechange', 'plan')
              //   this.querySubLoading = false
              //   return
              // }
              // this.getPlanDetail(item).then(chargeItems => {
              //   const _chargeItems = []
              //   chargeItems.forEach(i => {
              //     const addon = item.chargeItems.find(j => j.addonId === i.addonId) || {}
              //     _chargeItems.push({
              //       ...i,
              //       ...addon,
              //       displayName: AddonsInfo[i.addonId].displayName
              //     })
              //   })
              //   item.chargeItems = _chargeItems
              this.subscription = subPlans[0]
              this.allSubscriptions = subPlans
              this.hasSub = true

              this.$emit('titlechange', '')
            } else {
              this.hasSub = false
              // this.$emit('titlechange', 'Choose a plan')
              this.$emit('titlechange', '')
            }
          }
        } else if (errors && errors.length) {
          const { errorCode } = errors[0].extensions || {}
          if (errorCode == '80E00129') {
            MessageBox.alert("You don't belong to any Token User Group.Please contact your company's administrator.", { confirmButtonText: 'OK' })
          }
        }
        this.querySubLoading = false
      }).catch(error => {
        console.log(error)

        try {
          // this.handleCloseIframe()
          const { extensions } = error.graphQLErrors[0]
          const codes = ['80E00149']
          // Owner + Finance is allowed to be forwarded to Home’s Bill tab for the shortage of Token.
          // For other type of users, the error shows:  “Please contact your organization account owner or a Finance user to purchase tokens.”
          if (extensions && extensions.errorCode && codes.includes(extensions.errorCode)) {
            const params = {
              type: 'event',
              from: 'billing',
              data: {
                noTug: true
              }
            }
            window.parent.postMessage(params, '*')
            // console.log(this.initData.tvuHomePage)
            // if (groupRoles.includes(this.initData.groupRole)) {
            //   // window.open(this.initData.tvuHomePage)
            //   alert(this.initData.tvuHomePage)
            // } else {
            //   this.MessageBox && this.MessageBox.alert('Please contact your organization account owner or a Finance user to purchase tokens.', {
            //     confirmButtonText: 'OK'
            //   })
            // }
          }
        } catch (err) {

        }
      })
    },
    getPlanDetail (subscription) {
      const params = {
        customerId: this.emailid,
        product: this.product,
        planId: subscription.planId,
        excludeGlobal: true
      }
      return getPlans(params).then(({ data }) => {
        console.log(data)
        const plans = data.plan.plans
        const planDetail = plans[0]
        if (!planDetail) return []
        return planDetail.chargeItems
      })
    },
    titlechange (value) {
      this.$emit('titlechange', value)
    },
    // 重新选择plan   true -> manage  false -> choose
    // action manageSubs --> choose
    reselectPlan (value) {
      const action = value
      if (action == 'manageSubs') {
        // 从choose 返回manage subs
        this.nodeType = ''
        this.showManageSub = true
        // this.$emit('titlechange', 'Manage Subscriptions')
        this.$emit('titlechange', 'subscription')
      } else if (action == 'choose') {
        this.chooseFrom = 'manage'
        this.hasSub = false
        this.$emit('titlechange', '')
        // 从choose 返回manage
      } else if (action == 'manage') {
        // 从manage 进入choose
        if (this.iframeData.action == 'manage') {
          this.hasSub = true
          this.$emit('titlechange', '')
        } else {
          // const title = this.nodeType == 'cloud' ? 'Cloud Subscriptions' : 'Nodes Subscriptions'
          const title = this.nodeType == 'cloud' ? 'cloudSubscription' : 'node'
          this.hasSub = true
          this.$emit('titlechange', title)
        }
      }
    },
    handleChoosePlanType (type) {
      this.chooseFrom = 'manageSubs'
      this.nodeType = type
      this.showManageSub = false
      this.hasSub = false
      if (type == 'cloud') {
        this.subscription = this.cloudPlan
      } else {
        this.subscription = this.nodePlan
      }
      this.$emit('titlechange', '')
    },
    handleManagePlanType (id) {
      this.chooseFrom = 'manageSubs'
      // this.nodeType = type
      this.showManageSub = false
      this.hasSub = true
      // if (type == 'cloud') {
      //   this.subscription = this.cloudPlan
      // } else {
      //   this.subscription = this.nodePlan
      // }
      this.subscription = this.planList.find(i => i.id === id)
      this.subscription.chargeItems.forEach(i => {
        i.displayName = AddonsInfo[i.addonId].displayName
      })
      // const title = type == 'cloud' ? 'Cloud Subscriptions' : 'Nodes Subscriptions'
      this.$emit('titlechange', '')
    },
    planDisplayName (planId = '') {
      if (planId.includes('_monthly')) {
        return 'Monthly'
      } else if (planId.includes('_1y')) {
        return 'Yearly'
      } else if (planId.includes('_ppu')) {
        return 'Pay per Use'
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email,
      iframeData: 'iframeData',
      product: 'product'
    })
  }
}
</script>

<style lang="less" scoped>
#producer {
  min-width: 408px;
  min-height: 460px;
  .paysuccess-info {
    width: 408px;
    position: relative;
    .info-line {
      width: calc(100% - 80px);
      margin: 20px auto;
      height: 1px;
      background: var(--dialog-border-color);
    }
    .pay-content {
      height: 200px;
      padding: 0 40px;
      margin: 20px 0;
      // border-top: 1px solid var(--dialog-border-color);
      .info-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #DBDBDB;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid #666666;
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
        color: #DBDBDB;
      }
    }
  }
}
</style>
